import React from "react";
import {
  orderClassificationText,
  formatDateTime,
  formatPrice,
} from "../../../../utils";

const ExpandableTable = ({ data }) => {
  console.log(data);
  return (
    <div className="mt-4">
      <p className="text-sm font-bold">주문정보</p>
      <div className="flex pb-4 border-b-8 border-b-[#EDEDED] mt-2.5">
        <table className="table-fixed min-w-full">
          <tbody>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                주문번호
              </td>
              <td className="border border-disable-grey p-2 w-72">
                {data?.orderInformation?.orderNo}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                주문구분
              </td>
              <td className="border border-disable-grey p-2">
                {orderClassificationText(
                  data?.orderInformation?.orderClassification
                )}
              </td>
            </tr>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                주문일시
              </td>
              <td className="border border-disable-grey p-2">
                {formatDateTime(data?.orderInformation?.orderAt)}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                주문자
              </td>
              <td className="border border-disable-grey p-2">
                {data?.orderInformation?.customer?.name}&nbsp; (
                {data?.orderInformation?.customer?.email})
              </td>
            </tr>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                전화번호
              </td>
              <td className="border border-disable-grey p-2">
                {data?.orderInformation?.phone}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                배송지
              </td>
              <td className="border border-disable-grey p-2">
                ({data?.orderInformation?.shippingAddress?.postalCode}){" "}
                {data?.orderInformation?.shippingAddress?.address}{" "}
                {data?.orderInformation?.shippingAddress?.addressDetail}
              </td>
            </tr>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                대표자 연락처
              </td>
              <td className="border border-disable-grey p-2">
                {data?.orderInformation?.representativeContact}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                담당자 연락처
              </td>
              <td className="border border-disable-grey p-2">
                {data?.orderInformation?.contactPerson}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <p className="text-sm font-bold mt-3">결제 정보</p>
        <table className="table-fixed min-w-full mt-2.5">
          <tbody>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                결제상태
              </td>
              <td className="border border-disable-grey p-2 w-72">
                {data?.paymentInformation?.paidCompletedAt !== null
                  ? "결제 완료"
                  : "결제 미완료"}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                결제수단
              </td>
              <td className="border border-disable-grey p-2">
                {data?.paymentInformation?.paidType === "ACCOUNT"
                  ? "무통장 입금"
                  : "신용카드"}
              </td>
            </tr>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                결제정보
              </td>
              <td className="border border-disable-grey p-2">
                {data?.paymentInformation?.paidType === "CREDIT"
                  ? `${data?.paymentInformation?.paymentTransaction.issuerName} ${data?.paymentInformation?.paymentTransaction.cardNumber}`
                  : `세금계산서 ${data?.paymentInformation?.bankHolderBizNo} (${data?.paymentInformation?.bankHolderName})`}
              </td>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                승인일시(입금확인)
              </td>
              <td className="border border-disable-grey p-2">
                {data?.paymentInformation?.paidCompletedAt
                  ? formatDateTime(data?.paymentInformation?.paidCompletedAt)
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className="border border-disable-grey bg-input-grey w-32 p-2">
                결제금액
              </td>
              <td
                colSpan={3}
                className="border text-input-red border-disable-grey p-2"
              >
                {formatPrice(data?.paymentInformation?.paidPrice)}원
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="border-b-[12px] border-b-[#EDEDED] pb-6">
        <div className="max-w-sm">
          <p className="text-sm font-bold mt-7">결제금액 상세정보</p>
          <table className="min-w-full mt-2.5">
            <thead>
              <tr>
                <th className="border text-left w-28 border-disable-grey bg-input-grey p-1.5">
                  구분
                </th>
                <th className="border border-disable-grey bg-input-grey">
                  최초 결제금액
                </th>
                <th className="border border-disable-grey bg-input-grey">
                  최종 결제금액
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-disable-grey bg-input-grey p-1.5">
                  상품금액
                </td>
                <td className="border border-disable-grey p-1.5 text-right">
                  {formatPrice(
                    data?.paymentDetails?.productPrice?.initial ?? 0
                  )}
                </td>
                <td className="border border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.productPrice?.final ?? 0)}
                </td>
              </tr>
              <tr>
                <td className="border border-disable-grey text-title-blue bg-input-grey p-1.5">
                  -할인금액
                </td>
                <td className="border border-disable-grey text-title-blue p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.discount?.initial ?? 0)}
                </td>
                <td className="border border-disable-grey text-title-blue p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.discount?.final ?? 0)}
                </td>
              </tr>
              <tr>
                <td className="border border-disable-grey text-title-blue bg-input-grey p-1.5">
                  배송비
                </td>
                <td className="border text-title-blue border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.deliveryFee?.initial ?? 0)}
                </td>
                <td className="border text-title-blue border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.deliveryFee?.final ?? 0)}
                </td>
              </tr>
              <tr>
                <td className="border border-b-black border-disable-grey text-title-blue bg-input-grey p-1.5">
                  -포인트
                </td>
                <td className="border border-b-black text-title-blue border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.point?.initial ?? 0)}
                </td>
                <td className="border border-b-black text-title-blue border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.point?.final ?? 0)}
                </td>
              </tr>
              <tr>
                <td className="border border-disable-grey font-bold text-input-red bg-input-grey p-1.5">
                  총 결제금액
                </td>
                <td className="border text-input-red font-bold border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.total?.initial ?? 0)}
                </td>
                <td className="border text-input-red font-bold border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.total?.final ?? 0)}
                </td>
              </tr>
              <tr>
                <td className="border border-disable-grey font-bold text-input-red bg-input-grey p-1.5">
                  적립예정 포인트
                </td>
                <td className="border text-input-red font-bold border-disable-grey p-1.5 text-right">
                  {formatPrice(
                    data?.paymentDetails?.pointsEarned?.initial ?? 0
                  )}
                </td>
                <td className="border text-input-red font-bold border-disable-grey p-1.5 text-right">
                  {formatPrice(data?.paymentDetails?.pointsEarned?.final ?? 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ExpandableTable;
